import Warning from 'components/Warning/Warning';

export default Warning;
